module.exports = __webpack_public_path__ + "static/media/icon_file_sys.3763ef19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_sys.svg
// module id = 160
// module chunks = 0